module.exports = __webpack_public_path__ + "media/images/color_admin_v3/user-8-4aa794bf5bb5e4f96343d59297ca8445.jpg";